import React from 'react';
import styles from './index.modules.scss';
import { Input as MInput, Textarea as MTextarea } from '@mantine/core';

/**
 * 详见https://mantine.dev/core/input/
 *
 * @param {*} props
 * @returns
 */
export const Input = (props) => {
  const { className, ...rest } = props;
  return <MInput className={`${styles.input} ${className} relative`} {...rest} radius="4" />;
};

export const Textarea = (props) => {
  const { className, ...rest } = props;
  return <MTextarea className={`${styles.textarea} ${className} relative`} {...rest} radius="4" />;
};
